import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import GasStationStatementList from './list';
import GasStationStatementShow from './show';

export default {
    list: GasStationStatementList,
    show: GasStationStatementShow,
    icon: ReceiptTwoToneIcon,
};
